import controller from './home.controller';
import template from './home.html';
import './home.scss';
/**
 * @ngdoc component
 * @name home
 * @description
 * The home component of the app.
 *
 * @memberof rootModule
 */
export default {
  /**
   * The controller class for the component.
   * @type {HomeController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/home/components/home/home.component.js